<template>
  <table class="attribute-table uk-table uk-table-divider uk-table-justify">
    <tbody>
      <tr v-for="field in fieldsOrDefaultFields">
        <td
          :title="$t(`fields.${field}`)"
          class="attribute-table__key uk-table-shrink uk-text-right uk-text-bold"
        >
          {{$t(`fields.${field}`)}}
        </td>
        <td class="attribute-table__value">
          <slot :name="field" :value="data[field]" :row="data">
            <span v-if="data[field]">{{data[field]}}</span>
            <span v-else><text-placeholder /></span>
          </slot>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import TextPlaceholder from '@/components/TextPlaceholder';

export default {
  name: 'attribute-table',
  components: {
    TextPlaceholder,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    fields: Array,
  },
  computed: {
    fieldsOrDefaultFields() {
      if (this.fields) return this.fields;
      return Object.keys(this.data);
    },
  },
};
</script>

<style lang="scss">
.attribute-table__key {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 150px;
}
</style>



// WEBPACK FOOTER //
// AttributeTable.vue?efd78f04